import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto,
} from '../../services/wealthlane-award-services';

const useGetDashboardAdminTask = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Array<Wealthlane_AwardService_Dtos_AdminDashboard_AdminTaskDto> | undefined,
  unknown
> => {
  const dashboardAdminTask = useQuery(['getDashboardAdminTask'], async () => {
    return await handleRequest(DashboardService.getApiAwardApiAppDashboardAdminTasks());
  });

  return dashboardAdminTask;
};

export default useGetDashboardAdminTask;
